import { SubscriptionStatusEnum } from '../../models/enums/SubscriptionStatusEnum';
import { PlanSubscriptionPeriodEnum } from '../../models/enums/PlanSubscriptionPeriodEnum';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CurrentSubscribedPlan } from '../../models/SubscriptionPlan';

@Component({
  selector: 'app-current-subscription-card',
  standalone: false,
  templateUrl: './current-subscription-card.component.html'
})
export class CurrentSubscriptionCardComponent {
  subscriptionStatusEnum = SubscriptionStatusEnum;
  @Input({required: true}) subscription!: CurrentSubscribedPlan;
  @Output() renew = new EventEmitter<void>();

  get status(): SubscriptionStatusEnum {
    if (this.subscription.isExpired) return SubscriptionStatusEnum.EXPIRED;
    return this.subscription.isExpiredSoon ? SubscriptionStatusEnum.EXPIRING : SubscriptionStatusEnum.ACTIVE;
  }

  get expiryLabel(): string {
    if (this.subscription.planSubscriptionPeriodEnum === PlanSubscriptionPeriodEnum.YEAR && this.status !== SubscriptionStatusEnum.EXPIRED) {
      return 'profile.annualPlanExpiresOn';
    }
    return 'subscription.' + (this.subscription.planSubscriptionPeriodEnum === PlanSubscriptionPeriodEnum.YEAR ? 'yearly' : 'monthly') + (this.status === SubscriptionStatusEnum.EXPIRED ? 'PlanExpiredOn' : 'PlanExpiresOn');
  }

}
